import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { InvoicesContext } from '../../invoices-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const InvoiceTotalColumn = ({ invoiceId }) => {
  const { invoices } = useContext(InvoicesContext);
  const invoiceTotal = invoices[invoiceId]?.total;
  return (
    <div className={classnames(style['item-cell'], style['number-cell'])}>
      <FormattedCurrencyContainer currencyCode={invoiceTotal?.code} value={invoiceTotal?.value} />
    </div>
  );
};

InvoiceTotalColumn.propTypes = {
  invoiceId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.invoiceTotal} />,
  id: 'invoiceTotal',
  render: InvoiceTotalColumn,
};
